import { render } from "./NotificationEntity.vue?vue&type=template&id=4fa1e350&scoped=true"
import script from "./NotificationEntity.vue?vue&type=script&lang=js"
export * from "./NotificationEntity.vue?vue&type=script&lang=js"

import "./NotificationEntity.vue?vue&type=style&index=0&id=4fa1e350&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fa1e350"

export default script